import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { selectLicensesListItems } from "../../../../../redux/licenses/selector";
import { licenses } from "../../../../../redux/licenses/action";

const Licenses = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
    const licenseItems = useSelector(selectLicensesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'BusinessName', headerName: 'BusinessName', searchField: 'BusinessName', filter: true,
            filterType: 'text' },
          { field: 'SubscriptionName', headerName: 'Subscription'},
          { field: 'TotalNoOfNPSubscriptions', headerName: 'Total No Of NPSubscriptions ' },
          { field: 'CreatedOnUtc', headerName: 'CreatedOn ' ,isDateValueFormat:true},
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOn ' ,isDateValueFormat:true},
         
        ]);
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
    
        dispatch(licenses.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/licenses/list`,entity:'licenses',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
          }}))
      }
    
      const handleReloadData = () => {
        dispatch(licenses.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/licenses/list`,entity:'licenses',jsonData:{
      
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }}))
      }
      const filterTypes = [{
        name: 'Text', value: "text"
      },
      {
        name: 'Number', value: "number"
      },
      {
        name: 'CheckBox', value: "checkbox"
      },
      {
        name: 'Date', value: "date"
      }
      ]
      const additionButtons: any = [
        {
          svg:
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        // name: 'Reload',
        callback: () => handleReloadData(),
        },
      ];
      const handleEdit=(data: any)=>{
        navigate(`${data?.Id}`)
      }
        
      const fetchLicenses=()=>{
        dispatch(licenses.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/licenses/list`,entity:'licenses',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchLicenses()
	}, [pageData,pageSize])

	return (
    <>
    {licenseItems?.isLoading ?  <PageLoader />: 
		<Table  enableFilter={true}
    filterTypeLists={filterTypes}
    onSearch={handleSearch} columnData={columnDefs} rowData={licenseItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
    paginationData={licenseItems?.result?.pagination} onEdit={handleEdit} additionButtons={additionButtons} headingName="Licenses"/>
     
  }
  </> 
	);
};

export default Licenses;


